import Campaigns from '../../pages/mailcoach/Campaigns';
import ShowCampaign from '../../pages/mailcoach/ShowCampaign';

import EmailLists from '../../pages/mailcoach/EmailLists';
import CreateEmailList from '../../pages/mailcoach/CreateEmailList';
import EditEmailList from '../../pages/mailcoach/EditEmailList';
import EmailCampaignWizard from '../../pages/mailcoach/wizard/Wizard';
import WizardRecipients from '../../pages/mailcoach/wizard/Recipients';
import WizardReview from '../../pages/mailcoach/wizard/Review';
import WizardStart from '../../pages/mailcoach/wizard/Start';
import WizardTemplate from '../../pages/mailcoach/wizard/Template';
import {authGuard} from '../guards';

function getRoutes(routePrefix, layout) {

  let basePath = routePrefix === 'library'
    ? '/v2/app/content'
    : '/v2/mobile'

  return [
    {
      path: `${basePath}/campaigns`,
      name: `${routePrefix}.mailcoach.campaigns`,
      component: Campaigns,
      meta: {
        layout: layout,
        title: `Campaigns`,
        allow_restricted_user: false, // MLD-2750
      },
    },
    {
      path: `${basePath}/campaigns/:campaignID(\\d+)`,
      name: `${routePrefix}.mailcoach.campaign.show`,
      component: ShowCampaign,
      meta: {
        layout: layout,
        title: `Campaign`,
        allow_restricted_user: false, // MLD-2750
      },
    },
    {
      path: `${basePath}/lists`,
      name: `${routePrefix}.mailcoach.lists`,
      component: EmailLists,
      meta: {
        layout: layout,
        title: `Email Lists`,
        allow_restricted_user: false, // MLD-2750
      }
    },
    {
      path: `${basePath}/lists/create`,
      name: `${routePrefix}.mailcoach.list.create`,
      component: CreateEmailList,
      meta: {
        layout: layout,
        title: `New Email List`,
        allow_restricted_user: false, // MLD-2750
      }
    },
    {
      path: `${basePath}/lists/:listID(\\d+)/edit`,
      name: `${routePrefix}.mailcoach.list.edit`,
      component: EditEmailList,
      meta: {
        layout: layout,
        title: `Edit Email List`,
        allow_restricted_user: false, // MLD-2750
      }
    },
    {
      path: `${basePath}/campaign/wizard`,
      redirect: `${basePath}/campaigns/wizard`,
    },
    {
      path: `${basePath}/campaigns/wizard`,
      component: EmailCampaignWizard,
      meta: {
        layout: layout,
        title: `Email Campaign`,
        allow_restricted_user: false, // MLD-2750
      },
      children: [
        {
          path: ``,
          name: `${routePrefix}.mailcoach.campaign.wizard`,
          component: WizardStart,
          meta: {
            layout: layout,
            title: `Email Campaign`,
            allow_restricted_user: false, // MLD-2750
          },
        },
        {
          path: `recipients`,
          name: `${routePrefix}.mailcoach.campaign.wizard.recipients`,
          component: WizardRecipients,
          meta: {
            layout: layout,
            title: `Email Campaign`,
            allow_restricted_user: false, // MLD-2750
          },
        },
        {
          path: `template`,
          name: `${routePrefix}.mailcoach.campaign.wizard.template`,
          component: WizardTemplate,
          meta: {
            layout: layout,
            title: `Email Campaign`,
            allow_restricted_user: false, // MLD-2750
          },
        },
        {
          path: `review`,
          name: `${routePrefix}.mailcoach.campaign.wizard.review`,
          component: WizardReview,
          meta: {
            layout: layout,
            title: `Email Campaign`,
            allow_restricted_user: false, // MLD-2750
          },
        },
      ]
    },
  ];
}

export default [
  ...authGuard([
    ...getRoutes('library', 'content'),
    ...getRoutes('mobile', 'mobile'),
  ]),
]


